import { Button } from "@amzn/storm-ui";
import styled from "styled-components";

export const DesktopListComponentItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px 6px;
`;
export const DesktopListComponentButton = styled(Button)`
  text-align: start;
  width: 100%;
  border-radius: 8px;
  padding: 8px 14px;
  &:hover {
    background: ${({ theme }) => theme.palette.gray[50]};
  }
`;
export const MobileListComponentItemContainer = styled.div`
  margin-bottom: 0px;
`;
export const MobileListComponentContainer = styled.div`
  padding: 0px ${({ theme }) => theme.spacing.base};
`;